import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './OfflineBanner.scss';

export default function OfflineBanner() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showRestored, setShowRestored] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      setShowRestored(false);
    };

    const handleOnline = () => {
      setIsOnline(true);
      setShowRestored(true);
      setTimeout(() => setShowRestored(false), 3000);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (isOnline && !showRestored) return null;

  return (
    <div className={`offline-banner ${!isOnline ? 'offline-banner--offline' : 'offline-banner--restored'}`}>
      <FontAwesomeIcon icon={!isOnline ? faWifi : faCircleCheck} className="offline-banner__icon" />
      <span>
        {!isOnline
          ? 'Connexion internet perdue. Vérifiez votre réseau.'
          : 'Connexion rétablie.'}
      </span>
    </div>
  );
}
